import NavBarCtrl from './NavBarCtrl';

export default function () {
    return {
        restrict: 'EA',
        controller: NavBarCtrl
    };
}